/**
 * Indian mobile numbers are stored as E.164 (+91 followed by 10 digits) and displayed as
 * "+91 98765 43210". normalizePhone() accepts what people type or paste (spaces, dashes, a
 * leading 0, 91 / +91 / 0091 prefixes) and returns the stored form, or null when it is not a
 * 10-digit number.
 */
export function normalizePhone(input: string | null | undefined): string | null {
  if (!input) return null;
  let d = input.replace(/\D/g, '');
  if (d.startsWith('0091')) d = d.slice(4);
  else if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  if (!/^\d{10}$/.test(d)) return null;
  return `+91${d}`;
}

/** "+919876543210" → "+91 98765 43210"; anything else is returned as typed. */
export function fmtPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  const m = /^\+91(\d{5})(\d{5})$/.exec(phone);
  return m ? `+91 ${m[1]} ${m[2]}` : phone;
}

/** Digits only, for matching a search term against stored numbers. */
export const phoneDigits = (s: string) => s.replace(/\D/g, '');
